export const TAB_STORE_CLICKED = 'Tab - Store Clicked';

export const STORE_TAB_FILTER_APPLIED = 'Store - Tab Filter Applied';

export const STORE_FIND_CENTRE_CLICKED = 'Store - Find Centre Clicked';

export const storeSubscriptionTypes = {
  BATCH: 500,
  TEST_SERIES: 501
};

export const storeSubscriptionTypesLabel = {
  500: 'Batch',
  501: 'Test Series'
};

export const SINGLE_SELECT = 'single_select';
export const ALL = 'All';
